import { isSameDay } from 'date-fns';

export type CalendarDayCellArg = {
  date: Date;
  view: { type: string };
  isOther: boolean;
};

export function getCalendarDayCellClassNames(arg: CalendarDayCellArg, selectedDate: Date): string {
  if (arg.view.type !== 'dayGridMonth' || arg.isOther) {
    return '';
  }

  if (isSameDay(arg.date, selectedDate)) {
    return 'sf-calendar-month-day--selected';
  }

  return '';
}
